import { EComponentTypes } from "../../../Utils/Enums";
import { InstructorModel } from "../../../Utils/Models";
import { formatDate } from "../../../Utils/Utils";
import { Vocabulary } from "../../../Utils/Vocabulary";
import { localUrlEnum } from "../../../Utils/UrlEnum";

export const drivingHoursColumns = [
  {
    name: "incrementId",
    label: Vocabulary.order,
    options: {
      setCellProps: () => ({ style: { maxWidth: "90px", width: "90px" } }),
      setCellHeaderProps: () => ({ style: { maxWidth: "90px", width: "90px" } }),
    },
  },
  {
    name: "instructorName",
    label: Vocabulary.instructor,
  },
  {
    name: "clientName",
    label: Vocabulary.cursant,
    options: {
      customBodyRender: (value: string, tableMeta: any) => {
        const clientId = tableMeta.rowData[8];
        if (!clientId) return value;
        return (
          <a
            href={`${localUrlEnum.client}/${clientId}`}
            onClick={(e) => e.stopPropagation()}
            style={{ color: "inherit", textDecoration: "underline", cursor: "pointer" }}
          >
            {value}
          </a>
        );
      },
    },
  },
  {
    name: "product",
    label: Vocabulary.category,
  },
  {
    name: "distanceKm",
    label: Vocabulary.distance,
    options: {
      setCellProps: () => ({ style: { maxWidth: "90px", width: "90px" } }),
      setCellHeaderProps: () => ({ style: { maxWidth: "90px", width: "90px" } }),
    },
  },
  {
    name: "startDate",
    label: Vocabulary.date,
    options: {
      customBodyRender: (startDate: Date) => {
        return formatDate(startDate);
      },
      exportValue: (startDate: Date) => startDate ? formatDate(startDate) : "",
    },
  },
  {
    name: "startDate",
    label: Vocabulary.startHour,
    options: {
      customBodyRender: (date: Date) => {
        return formatDate(date, "HH:mm");
      },
      exportValue: (date: Date) => date ? formatDate(date, "HH:mm") : "",
    },
  },
  {
    name: "endDate",
    label: Vocabulary.endHour,
    options: {
      customBodyRender: (date: Date) => {
        return formatDate(date, "HH:mm");
      },
      exportValue: (date: Date) => date ? formatDate(date, "HH:mm") : "",
    },
  },
  {
    name: "clientId",
    label: "",
    options: {
      display: "excluded" as any,
      filter: false,
      sort: false,
      download: false,
      print: false,
    },
  },
];

/**
 * Generates an array of filter objects for the driving hours report.
 *
 * @param {InstructorModel[]} instructors - The list of instructors to use for the autocomplete filter.
 *
 * @returns {Array<Filter>} An array of filter objects.
 */
export const drivingHoursFilters = (instructors: InstructorModel[]) => [
  {
    property: "instructorId",
    autocompleteFilterProperty: "instructorId",
    label: Vocabulary.instructor,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: null,
    options: instructors,
  },
];
